/**
 * filtros usuarios
 */

/**
 * [RoleName description]
 * @param {number} value [description]
 */
export function StatusName(value) {
  switch (value) {
    case 0:
      return "Inactivo";
    case 1:
      return "Habilitado";
    case 2:
      return "Pausa";
    case 3:
      return "Bloqueado";
    case 4:
      return "Documentacion";
    default:
      return "---";
  }
}

/**
 * [Queue Estatus description]
 * @param {string} value [description]
 */
export function StatusQueueName(value) {
  if (value) {
    switch (value) {
      case "Added":
        return { name: "Conectado", color: "success" };
      case "Command":
        return { name: "Falla", color: "warning" };
      case "Removed":
        return { name: "Desconectado", color: "error" };
      default:
        return {};
    }
  } else {
    return "---";
  }
}
